import { ApolloProvider as CoreApolloProvider } from "@apollo/client";
import { ReactNode } from "react";
import { client } from "../../constants/client";

export function ApolloProvider({ children }: { children: ReactNode }) {
  return <CoreApolloProvider client={client}>{children}</CoreApolloProvider>;
}
